export class Hospital {
  id: number;
  nome: string;
  cnpj: string;
  empresaId?: number;

  constructor(id = 0, nome = "", cnpj = "", empresaId = 0) {
    this.id = id;
    this.nome = nome;
    this.cnpj = cnpj;
    this.empresaId = empresaId;
  }
}
